import React from 'react'
import { FormRenderProps } from 'react-final-form'
import checkPermission from '../../../../../../utilities/checkPermission'
import * as memoMessageType from './resultOfConsiderType'
import useAppFolderAndTabAction from '../../../../../../stores/appFolderAndTab/appFolderAndTabAction'
import _ from 'lodash'
import { RoutePath } from '../../../../../../router/routesConfig'
import { useHistory } from 'react-router-dom'
import { DialogType } from '../../../../../../control/dialog/dialog'
import useLoading from '../../../../../../control/loading/useLoading'
import * as REQServiceType from '../../../../../../services/web/types/requestWebServiceTypes'
import useAuthenStore from '../../../../../../stores/authen/authenStore'
import useTranslate from '../../../../../../i18n/useTranslate'
import useWebService from '../../../../../../services/web/useWebService'
import useFolderAndTab from '../../../useFolderAndTab'
import useLookupService from '../../../../../../services/lookup/useLookupService'
import { DataSourceType } from '../../../../../../control/treeCheckboxNew/treeCheckbox'
import useManageProjectStore from '../../../../../../stores/manageProject/useManageProjectStore'
import { dateForAPI } from '../../../../../../utilities/date'
import { InitialRichTextEditorType } from '../../../../../../control/richTextEditor/richTextEditor'
import { memorandumTopic } from '../../../../../../constants/constants'
import constSubmittedType from '../../../../../../constants/submittedType'
import { UploadFileObjCerType } from '../../generateCertificate/generateCertificateType'
import useAppAlertMessageAction from '../../../../../../stores/appAlertMessage/appAlertMessageAction'
import constConsiderType from '../../../../../../constants/considerType'
import { ResultCertificateCloseProjectResponse } from '../../../../../../services/web/types/responseWebServiceTypes'

const useMemomessageTerminate = (props: memoMessageType.UseMemoMessageType) => {
    const { onSaveComplete } = props
    const appAlertMessageAction = useAppAlertMessageAction()
    const callWebService = useWebService()
    const checkPermissionHook = checkPermission()
    const tabAndFolderHook = useFolderAndTab()
    const history = useHistory()
    const translate = useTranslate()
    const loadingHook = useLoading()
    const appFolderAndTabAction = useAppFolderAndTabAction()
    const authenStore = useAuthenStore()
    const manageProjectStore = useManageProjectStore()
    const projectData = manageProjectStore.projectData

    const [initialValues, setInitialValues] = React.useState<any>({})
    const [required, setRequired] = React.useState<boolean>(true)

    const isViewMode = checkPermissionHook.chkProjectStepViewMode(projectData)
    const [configDialog, setConfigDialog] =
        React.useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const dialogRef = React.useRef<Record<string, Function>>()
    const formRef = React.useRef<FormRenderProps>()
    const callLookup = useLookupService()

    const [initialSuggestionNotice, setInitialSuggestionNotice] = React.useState<InitialRichTextEditorType>()
    // const [initialMemoMessagePaper, setInitialMemoMessagePaper] = React.useState<{
    //     TH: InitialRichTextEditorType
    //     EN: InitialRichTextEditorType
    // }>()
    const [initialMemorandumFile, setInitialMemorandumFile] = React.useState<any>()
    const [approveStatus, setApproveStatus] = React.useState<memoMessageType.OptType[]>([])

    React.useEffect(() => {
        if (projectData) {
            createInitialData()
        }

        if (projectData?.considerInfo && projectData?.considerInfo?.value) {
            setRequired(projectData?.considerInfo?.value === constConsiderType.exempt ? false : true)
        }

        // }, [JSON.stringify(projectData)])
    }, [projectData?.projectID ?? null, projectData?.submittedID ?? null, projectData?.considerInfo ?? null])

    React.useEffect(() => {
        getApproveStatus()
    }, [translate.languageStore.currentLanguage])

    const getApproveStatus = async () => {
        let res
        if (projectData?.irb) {
            res = await callLookup.callApproveStatusLut(projectData?.irb, constSubmittedType.adverseEvent)
            if (res) {
                const formatedData = res?.result?.map((itm) => {
                    return {
                        label:
                            translate.languageStore.currentLanguage === translate.languageKey.th
                                ? itm.name_th
                                : itm.name_en,
                        value: `${itm.id}`,
                    }
                }) as []
                setApproveStatus(formatedData)
            }
        }
    }

    const getMemoMessage = async () => {
        const submittedID = manageProjectStore?.projectData?.submittedID ?? null
        if (submittedID) {
            const { result } = await callWebService.getCertificateCloseProject(submittedID)
            return result
        }
    }

    const onRefDialog = (func: Record<string, Function>) => {
        //ห้าม set State หรือเรียก Action ในนี้
        dialogRef.current = func
    }

    /**
     * Default value form
     */
    const createInitialData = async () => {
        const result = await getMemoMessage()
        if (result) {
            const initialData = {
                memoMessageDate: result.memoMessageCommentDate ? new Date(result.memoMessageCommentDate) : new Date(),
                approveStatus:
                    result && result?.approveStatusInfo
                        ? {
                              label:
                                  translate.languageStore.currentLanguage === translate.languageKey.th
                                      ? result.approveStatusInfo.nameTH
                                      : result.approveStatusInfo.nameEN,
                              value: result?.approveStatusInfo.value.toString(),
                          }
                        : null,
            }

            /******* SuggestionNotice ********/
            const initialSugestionNotice = createInitialSuggestion(result)
            //************ file *************/
            const initialMemorandumFile = createInitialFileMemorandum(result)

            /******set state *******/
            setInitialValues(initialData)
            setInitialMemorandumFile(initialMemorandumFile)
            setInitialSuggestionNotice(initialSugestionNotice)
        }
    }

    /**
     * SuggestionNotice
     */

    const createInitialSuggestion = (content: ResultCertificateCloseProjectResponse) => {
        const initialSugestionNotice = {
            contentHtml: content?.synthesisReviewRemark_html,
            contentText: content?.synthesisReviewRemark,
        }
        return initialSugestionNotice
    }

    /**
     * file
     */

    const createInitialFileMemorandum = (content: ResultCertificateCloseProjectResponse) => {
        const uploadFileMemoranduminit: Array<UploadFileObjCerType> = memorandumTopic?.map((itm: any, idx: number) => {
            return {
                uploadFileObj: {
                    fileList: [],
                    subTopicPageList: [],
                    documentTopicID: itm.id,
                },
            }
        })
        uploadFileMemoranduminit.forEach((itm: UploadFileObjCerType) => {
            if (itm.uploadFileObj.documentTopicID === 0) {
                let fileListTH = {
                    documentTopicID: 0,
                    fileToken: content?.memoMessagePaperInfo.name_th,
                    filename: content?.memoMessagePaperInfo.name_th,
                    fileID: content?.memoMessagePaperInfo.name_th,
                    path: content?.memoMessagePaperInfo.signPathInfo.path_th,
                }
                //@ts-ignore
                itm.uploadFileObj.fileList.push(fileListTH)
            } else if (itm.uploadFileObj.documentTopicID === 1) {
                let fileListEN = {
                    documentTopicID: 1,
                    fileToken: content?.memoMessagePaperInfo.name_en,
                    filename: content?.memoMessagePaperInfo.name_en,
                    fileID: content?.memoMessagePaperInfo.name_en,
                    path: content?.memoMessagePaperInfo.signPathInfo.path_en,
                }
                //@ts-ignore
                itm.uploadFileObj.fileList.push(fileListEN)
            }
        })
        return uploadFileMemoranduminit
    }

    const handleClickBackToSearch = () => {
        history.push(RoutePath.manageProject)
    }

    const handleClickOpenFile = async (url: string) => {
        let xmlHttp = new XMLHttpRequest()
        xmlHttp.open('GET', url, true) // false for synchronous request
        xmlHttp.onreadystatechange = function () {
            // In local files, status is 0 upon success in Mozilla Firefox
            if (xmlHttp.readyState === XMLHttpRequest.DONE) {
                var status = xmlHttp.status
                if (status === 0 || (status >= 200 && status < 400)) {
                    // The request has been completed successfully
                    window.open(url)
                } else {
                    // Oh no! There has been an error with the request!
                    appAlertMessageAction.openAlertMessage({
                        title: translate.get('ALERT.TITLE.NOTIFICATION'),
                        message: translate.get('MESSAGE.M011'),
                    })
                }
            }
        }
        xmlHttp.send()
    }
    const handleChangeStatus = () => {}
    return {
        formRef,
        configDialog,
        isViewMode: isViewMode,
        initialValues,
        initialMemorandumFile,
        initialSuggestionNotice,
        required,
        approveStatus,
        onRefDialog,
        onClickBackToSearch: handleClickBackToSearch,
        onClickOpenFile: handleClickOpenFile,
        onChangeStatus: handleChangeStatus,
    }
}

export default useMemomessageTerminate
